import { Image } from '@mantine/core';
import { SecodaMinimalLogo } from '@repo/common/components';
import { integrationList } from '@repo/common/constants/integration/integrations';
import { ENTITY_NODE_HEADER_INTEGRATION_ICON_SIZE } from '../EntityNodeHeader/EntityNodeHeader.constants';
import type { EntityIconProps } from './EntityIcon.types';

function IntegrationTypeIcon({
	integrationType,
	size = ENTITY_NODE_HEADER_INTEGRATION_ICON_SIZE,
}: Pick<EntityIconProps, 'integrationType'> & { size?: number }) {
	const iconSrc = integrationType
		? integrationList.find(
				(i) => i.type.toLowerCase() === integrationType.toLowerCase()
			)?.src
		: undefined;

	if (!iconSrc) {
		return <SecodaMinimalLogo width={size} height={size} />;
	}

	return <Image src={iconSrc} width={size} height={size} />;
}

export default IntegrationTypeIcon;
